import React, { useEffect,useState,createRef } from 'react';
import { Button } from 'react-bootstrap';

import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
//import * as NumericInput from "react-numeric-input";
import NumberFormat from 'react-number-format';
import FittedImage from 'react-fitted-image';


import * as RestService from '../../services/eisRest';





  const BasicInformationsTab = (props) => {

   

    const [t] = useTranslation();      
 //   const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();   
    const [article, setArticle] = useState([]);
  //  const [serialNumber, setSerialNumber] = useState(null);
    
    const [sellingPriceExcludeVat, setSellingPriceExcludeVat] = useState(0);
    const [sellingPriceIncludeVat, setSellingPriceIncludeVat] = useState(0);
    const [purchasePriceExcludeVat, setPurchasePriceExcludeVat] = useState(0);
    const [purchasePriceIncludeVat, setPurchasePriceIncludeVat] = useState(0);
    const [vat, setVat] = useState(0);
    
    
    const [specificationList, setSpecificationList] = useState([]);   
    const [articleCategoryList, setArticleCategoryList] = useState([]);    
    const [articleProductLineList, setArticleProductLineList] = useState([]);    
    
    
    const [openAlertDialog, setOpenAlertDialog] = useState(false);

    const [articleImage, setArticleImage] = useState();
    const formikRef = createRef();

    const goodsOrServiceOptions = [
      { value: 'GDS', label: 'GDS' },
      { value: 'SRV', label: 'SRV' }
    ];

    const vatOptions = [
      { value: 0, label: '0' },
      { value: 10, label: '10' },
      { value: 20, label: '20' },
      { value: 21, label: '21' },
      { value: 23, label: '23' },
    ];

    const measureUnitOptions = [   
      { value: 'hour', label: t('general.um.hour') },
      { value: 'kg', label: t('general.um.kg') },
      { value: 'pcs', label: t('general.um.pcs') },
      { value: 'liter', label: t('general.um.liter') },
      { value: 'meter', label: t('general.um.meter') }
    ];
  
    const yesNoOptions = [
      { value: 1, label:  t('general.label.yes')},
      { value: 0, label:  t('general.label.no')}                  
    ];

    const hideModal = () => {
      props.parentCallback();
    };
    

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    const vatCalc = (price,vat) => {			
      var priceN = Number(price);
      var vatN  =Number(vat);		
      return (priceN/100)*(vatN+100);		
    }

    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('article/getArticle?id='+props.selectedRecord, null)
      .then((data) => {
           setArticle(data);
           props.loadedObject(data);
           getArticleImage(props.selectedRecord);
           setSellingPriceExcludeVat(data.sellingPriceExcludeVat);
           setSellingPriceIncludeVat(data.sellingPriceIncludeVat);
           setPurchasePriceExcludeVat(data.purchasePriceExcludeVat);
           setPurchasePriceIncludeVat(data.purchasePriceIncludeVat);
           setVat(data.vat);
           //setSerialNumber(data.serialNumber);
      }).catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=article&id='+selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      //  console.log("ArticleDatatable state.recordId:"+id);       
    }

    useEffect(() => {
      RestService.callAnyApi('article/getArticleSpecificationOptions', null).then((data) => { setSpecificationList(data);}).catch((error) => {});
      RestService.callAnyApi('article/getArticleCategoryList', null).then((data) => { setArticleCategoryList(data);}).catch((error) => {});
      RestService.callAnyApi('article/getArticleProductLineList', null).then((data) => { setArticleProductLineList(data);}).catch((error) => {});
      
      
    }, []);

    const recalcVat = (vat) =>{
      setSellingPriceIncludeVat( vatCalc(sellingPriceExcludeVat,vat));
      setPurchasePriceIncludeVat( vatCalc(purchasePriceExcludeVat,vat));
    }


    const handleChange = (e,elementName) => {
      
     
          switch(elementName){
              case "sellingPriceExcludeVat":
                setSellingPriceExcludeVat(e.floatValue);
                setSellingPriceIncludeVat( vatCalc(e.floatValue,vat));
              break; 
              case "sellingPriceIncludeVat":
                 setSellingPriceIncludeVat(e.floatValue);
              break;
              case "purchasePriceExcludeVat":
                 setPurchasePriceExcludeVat(e.floatValue);
                 setPurchasePriceIncludeVat( vatCalc(e.floatValue,vat));
              break;    
              case "purchasePriceIncludeVat":                                    
                   setPurchasePriceIncludeVat(e.floatValue);
              break;
              default:
          }          
     
    };

    const handleNumericChange =(k,value)=>{
     
     
     
      // console.log(value);
       switch(k){
           case "sellingPriceExcludeVat":
               setSellingPriceExcludeVat(value);
               setSellingPriceIncludeVat( vatCalc(value,vat));
           break;
           case "sellingPriceIncludeVat":
               setSellingPriceIncludeVat(value);
           break;
           case "purchasePriceExcludeVat":
               setPurchasePriceExcludeVat(value);
               setPurchasePriceIncludeVat( vatCalc(value,vat));
           break;    
           case "purchasePriceIncludeVat":
               setPurchasePriceIncludeVat(value);
           break;    
           
       }
   }

    const numberFormat = (num) => {
      return  parseFloat(num.replace(",", "."));
    }


    const getArticleImage = (selectedRecord) => {  
      RestService.callAnyApi('file/getFileByEntityId?entityId='+selectedRecord, '[]')
      .then((data) => {                                     
              try{
                setArticleImage(data.fileBody);                
              }catch(error){
                  console.error();
              }
             
      })
      .catch((error) => {               
          toast.error(
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                  'Failed'
          );
      });
    
    }



    const uploadArticleImage = (event) =>{

      RestService.uploadFile(event.target.files[0],null,selectedRecord,selectedRecord,"articleImage","1")
        .then((response) => {         
          setArticleImage(response.data.message);         
        })        
        .catch((error) => {
          toast.error(error);
        });    
    }

   // const onArticleSave = (data) =>{
   //   setArticle(data);
   //   props.parentCallback(isOpen);
  //    hideModal();
  //  }    
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      article.name = values.name;
      article.nbr = values.nbr;
      article.ean = values.ean;
      article.specificationId = values.specificationId;
      article.measureUnit = values.measureUnit;
      article.goodsOrService = values.goodsOrService;
      article.vat = values.vat;
      article.serialNumber = values.serialNumber;
      article.articleCategoryId = values.articleCategoryId;
      article.articleProductLineId = values.articleProductLineId;
      article.description = values.description;

      article.sellingPriceExcludeVat = sellingPriceExcludeVat;
      article.sellingPriceIncludeVat = sellingPriceIncludeVat;
      article.purchasePriceExcludeVat = purchasePriceExcludeVat;
      article.purchasePriceIncludeVat = purchasePriceIncludeVat;

      RestService.callAnyApi(url, article)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          setArticle(data.responseObject);
                          toast.success(t('general.message.saveSucceed'));     
                          setSelectedRecord(data.responseObject.id);
                          props.loadedObject(data.responseObject);                                         
                          //hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      ref: formikRef,      
      initialValues: {    
        name: article.name || "",
        nbr: article.nbr || "",
        ean: article.ean || "",
        goodsOrService: article.goodsOrService || "",
        specificationId:  article.specificationId || "",
        measureUnit:  article.measureUnit || "",
        vat: article.vat || 0,
        serialNumber: article.serialNumber || 0,
        articleCategoryId: article.articleCategoryId || "",
        articleProductLineId: article.articleProductLineId || "",
        description:  article.description || ""
      },
      validationSchema: Yup.object({
         name: Yup.string()     
          .required(t('general.message.required')),
       //  nbr: Yup.string()     
       //   .required(t('general.message.required'))
          
      }),
      onSubmit: (values) => {           
          save('article/saveArticle',values);         
      }
    });

    return (
      <>    
         <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>     
                    <form onSubmit={formik.handleSubmit}>     
                  
                        <div className="row">
                        
                            <div className="col-8 col-sm-8 col-lg-8">
                              <div className="form-group">
                                <label>{t('general.label.name')}</label>
                                <input type="text" class="form-control" placeholder={t('general.label.name')} {...formik.getFieldProps('name')} />
                              </div>
                              {formik.touched.name && formik.errors.name ? (<div style={{ color: 'red' }}>{formik.errors.name}</div>) : null} 
                            </div>         

                            <div className="col-4 col-sm-4 col-lg-4">
                              <div className="form-group">
                                <label>{t('article.label.articleNumber')}</label>
                                <input type="text" readOnly class="form-control" placeholder={t('article.label.articleNumber')} {...formik.getFieldProps('nbr')} />
                              </div>
                              {formik.touched.nbr && formik.errors.nbr ? (<div style={{ color: 'red' }}>{formik.errors.nbr}</div>) : null} 
                            </div>   


                       
                            
                        </div>      

                        <div className="row">

                             <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                <label>{t('article.label.specification')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('specificationId',value.value)}
                                      value={formik.values.specificationId}
                                      options={specificationList}     
                                />                                
                                </div>                             
                            </div>    


                            <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                <label>{t('article.label.measureUnit')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('measureUnit',value.value)}
                                      value={formik.values.measureUnit}
                                      options={measureUnitOptions}     
                                />                                
                                </div>                             
                            </div>    


                            <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                <label>{t('article.label.goodsOrService')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('goodsOrService',value.value)}
                                      value={formik.values.goodsOrService}
                                      options={goodsOrServiceOptions}     
                                />                                
                                </div>                             
                            </div>   


                            <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                  <label>{t('article.label.ean')}</label>
                                  <input type="text" class="form-control" placeholder={t('article.label.ean')} {...formik.getFieldProps('ean')} />
                                </div>
                                {formik.touched.ean && formik.errors.ean ? (<div style={{ color: 'red' }}>{formik.errors.ean}</div>) : null} 
                            </div>

                        </div>                                             


                        <div className="row">

                              <div class="col-7 col-sm-7 col-lg-7">  

                                  <div className="row">

                                      <div className="col-6 col-sm-6 col-lg-6">
                                          <div className="form-group">
                                            <label>{t('article.label.sellingPriceExcludeVat')}</label>                                          
                                            <NumberFormat displayType="input" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'}  value={sellingPriceExcludeVat} onValueChange={(values)  => {handleChange(values,"sellingPriceExcludeVat")}} />   
                                        </div>
                                      </div>

                                      <div className="col-6 col-sm-6 col-lg-6">
                                          <div className="form-group">
                                            <label>{t('article.label.sellingPriceIncludeVat')}</label>                                            
                                            <NumberFormat displayType="input" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'}  value={sellingPriceIncludeVat} onValueChange={(values)  => {handleChange(values,"sellingPriceIncludeVat")}} />   
                                        </div>
                                      </div>

                                  </div>

                             </div>

                   					 <div className="col-5 col-sm-5 col-lg-5">

                                  <div className="row">
                                  <div className="col-5 col-sm-5 col-lg-5">
                                      <div className="form-group">
                                      <label>{t('article.label.vat')}</label>                               
                                      <CustomSelect
                                            className='input'
                                            onChange={value=>{formik.setFieldValue('vat',value.value); setVat(value.value); recalcVat(value.value); }}
                                            value={formik.values.vat}
                                            options={vatOptions}     
                                      />                                
                                      </div>   

                                  </div>
                                  <div className="col-7 col-sm-7 col-lg-7">
                                        <div className="form-group">
                                      <label>{t('article.label.sn')}</label>                               
                                      <CustomSelect
                                          className='input'
                                          onChange={value=>{formik.setFieldValue('serialNumber',value.value);  }}
                                          value={formik.values.serialNumber}
                                          options={yesNoOptions}     
                                      />                  
                                      </div>                             
                                  </div>   
                                  </div>
                                
                             </div>

                             

                        </div>

                        <div className="row">

                              <div className="col-7 col-sm-7 col-lg-7">

                                    <div className="row">

                                          <div className="col-6 col-sm-6 col-lg-6">
                                              <div className="form-group">
                                                <label>{t('article.label.purchasePriceExcludeVat')}</label>                                                        
                                                <NumberFormat displayType="input" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} value={purchasePriceExcludeVat} onValueChange={(values)  => {handleChange(values,"purchasePriceExcludeVat")}} />   
                                            </div>
                                          </div>

                                          <div className="col-6 col-sm-6 col-lg-6">
                                              <div className="form-group">
                                                <label>{t('article.label.purchasePriceIncludeVat')}</label>                                                
                                                <NumberFormat displayType="input" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'}  value={purchasePriceIncludeVat} onValueChange={(values)  => {handleChange(values,"purchasePriceIncludeVat")}} />                                            
                                            </div>
                                          </div>

                                    </div>

                                    <div className="row">

                                          <div className="col-6 col-sm-6 col-lg-6">
                                            <div className="form-group">
                                            <label>{t('article.label.articleCategory')}</label>                               
                                            <CustomSelect
                                                  className='input'
                                                  onChange={value=>formik.setFieldValue('articleCategoryId',value.value)}
                                                  value={formik.values.articleCategoryId}
                                                  options={articleCategoryList}     
                                            />                                
                                            </div>                             
                                          </div>   


                                          <div className="col-6 col-sm-6 col-lg-6">
                                            <div className="form-group">
                                            <label>{t('article.label.articleProductLine')}</label>                               
                                            <CustomSelect
                                                  className='input'
                                                  onChange={value=>formik.setFieldValue('articleProductLineId',value.value)}
                                                  value={formik.values.articleProductLineId}
                                                  options={articleProductLineList}     
                                            />                                
                                            </div>                             
                                          </div>   

                                    </div>

                                    <div className="row">

                                          <div className="col-12 col-sm-12 col-lg-12">
                                              <div className="form-group">
                                                  <label>{t('general.label.description')}</label>
                                                  <input type="text" class="form-control" placeholder={t('general.label.description')} {...formik.getFieldProps('description')} />
                                              </div>
                                              {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                                          </div>

                                    </div>

                              </div>

                              <div className="col-5 col-sm-5 col-lg-5  d-flex align-items-center justify-content-center">


                                    <div className="col-12 col-sm-12 col-lg-12" >
                                        <div className="shadow  bg-white rounded justify-content-center" style={{"margin-top": "25px"}}> {/*p-3 mb-3*/}
                                            <div className="form-group  d-flex align-items-center justify-content-center" >
                                                <label>      										                 
                                                    <input type="file" accept="image/png" onChange={uploadArticleImage} style={{"display": "none"}} />
                                                    <FittedImage border="1"  style={{'max-width': '200px','max-height': '200px'}}  fit="auto" src={articleImage ? `data:image/png;base64,${articleImage}` : require('../../img/no_image.png')} alt=""/>
                                                </label>
                                            </div>
                                        </div>
                                    </div>



                              </div>

                         </div>

                         <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={hideModal}>{t('general.button.cancel')}</Button>                                                        	            	       			
                  			</div>

                  </form>

              </div>    


      </>
    );
  };

 export default BasicInformationsTab;